var Regions;
(function (Regions) {
    Regions["EU"] = "eu-west-1";
    Regions["US"] = "us-west-2";
})(Regions || (Regions = {}));
export default Regions;
